<nz-input-wrapper style="margin-bottom: 12px">
    <input
        nz-input
        [(ngModel)]="searchValue"
        placeholder="Search by document type or user..."
        (keydown.enter)="onSearch()" />
    <span nzInputSuffix>
        @if (searchValue) {
            <i
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                style="cursor: pointer; color: #bbb"
                (click)="clearSearch()"></i>
        }
    </span>
</nz-input-wrapper>

<nz-table
    #scanTable
    nzSize="small"
    [nzData]="scansList.Items"
    nzShowSizeChanger
    nzTableLayout="fixed"
    nzBordered="true"
    [nzFrontPagination]="false"
    [nzLoading]="loading"
    [nzTotal]="total"
    [nzShowTotal]="totalTemplate"
    [nzPageSize]="pageSize"
    [nzPageSizeOptions]="pageSizeOptions"
    [nzPageIndex]="pageIndex"
    (nzQueryParams)="onQueryParamsChange($event)">
    <thead>
        <tr>
            <th nzWidth="100px" nzAlign="center">Preview</th>
            <th
                nzColumnKey="DocumentType"
                [nzSortFn]="columns[1].compare"
                [nzShowSort]="true"
                [nzSortOrder]="getSortOrder('DocumentType')"
                [nzFilters]="docTypeFilters"
                [nzFilterFn]="true">
                Document Type
            </th>
            <th
                nzColumnKey="Timestamp"
                [nzSortFn]="columns[2].compare"
                [nzShowSort]="true"
                [nzSortOrder]="getSortOrder('Timestamp')">
                Timestamp
            </th>
            <th
                nzColumnKey="UserLock"
                [nzSortFn]="columns[3].compare"
                [nzShowSort]="true"
                [nzSortOrder]="getSortOrder('UserLock')"
                [nzFilters]="userLockFilters"
                [nzFilterFn]="true">
                Locked By
            </th>
            <th nzWidth="80px" nzAlign="center">Actions</th>
        </tr>
    </thead>
    <tbody>
        @for (scan of scansList.Items; track scan.ScanID) {
            <tr style="height: 116px">
                <td style="text-align: center; vertical-align: middle">
                    @if (scan.ScanStatus < 2) {
                        <span style="color: darkgray">Processing...</span>
                    }
                    @if (scan.ScanStatus === 2) {
                        @if (canViewScan(scan)) {
                            <a [routerLink]="'/scan/process'" [queryParams]="{id: scan.ScanID}">
                                <img
                                    alt="Scan"
                                    loading="lazy"
                                    class="scanimg"
                                    nz-popover
                                    nzPopoverTrigger="hover"
                                    nzPopoverOverlayClassName="scan-preview-popover"
                                    [nzPopoverContent]="previewUrls[$any(scan.ScanID)] ? zoomTpl : undefined"
                                    [nzPopoverPlacement]="['right', 'rightTop', 'rightBottom']"
                                    [src]="thumbUrls[$any(scan.ScanID)]"
                                    style="width: 70px; height: 100px; object-fit: contain" />
                            </a>
                        }
                        @if (!canViewScan(scan)) {
                            <img
                                alt="Scan"
                                loading="lazy"
                                class="scanimg"
                                nz-popover
                                nzPopoverTrigger="hover"
                                nzPopoverOverlayClassName="scan-preview-popover"
                                [nzPopoverContent]="previewUrls[$any(scan.ScanID)] ? zoomTpl : undefined"
                                [nzPopoverPlacement]="['right', 'rightTop', 'rightBottom']"
                                [src]="thumbUrls[$any(scan.ScanID)]"
                                style="width: 70px; height: 100px; object-fit: contain" />
                        }
                        <ng-template #zoomTpl>
                            <img alt="Scan preview" [src]="previewUrls[$any(scan.ScanID)]" style="height: 580px" />
                        </ng-template>
                    }
                </td>
                <td>
                    @if (canViewScan(scan)) {
                        <a [routerLink]="['/scan/process']" [queryParams]="{id: scan.ScanID}">
                            <span [innerText]="scan.DocumentType"></span>
                        </a>
                    }
                    @if (!canViewScan(scan)) {
                        <span title="Unlock to view" [innerText]="scan.DocumentType"></span>
                    }
                </td>
                <td>
                    <span style="font-size: 13px" [innerText]="scan.Timestamp | date: 'M/d/yy h:mm a'"></span>
                </td>
                <td>
                    @if (!scan.Locked) {
                        <span style="color: #bbb; font-size: 12px">—</span>
                    }
                    @if (scan.Locked && scan.CanUnlock) {
                        <span
                            [nz-tooltip]="'Click to unlock'"
                            nz-popconfirm
                            nzOkText="Unlock"
                            [nzOkDanger]="true"
                            nzPopconfirmTitle="Are you sure you want to unlock this scan?"
                            nzPopconfirmPlacement="top"
                            (nzOnConfirm)="unlockScan(scan.ScanID)"
                            style="
                                cursor: pointer;
                                font-size: 11px;
                                display: inline-flex;
                                align-items: center;
                                gap: 4px;
                                background: #f0f0f0;
                                color: #555;
                                border: 1px solid #d9d9d9;
                                border-radius: 10px;
                                padding: 2px 10px 2px 8px;
                                line-height: 20px;
                            ">
                            <i class="fa-solid fa-lock" style="font-size: 10px; color: #888"></i>{{ scan.UserLock }}
                        </span>
                    }
                    @if (scan.Locked && !scan.CanUnlock) {
                        <span
                            style="
                                font-size: 11px;
                                display: inline-flex;
                                align-items: center;
                                gap: 4px;
                                background: #f0f0f0;
                                color: #999;
                                border: 1px solid #d9d9d9;
                                border-radius: 10px;
                                padding: 2px 10px 2px 8px;
                                line-height: 20px;
                            ">
                            <i class="fa-solid fa-lock" style="font-size: 10px; color: #bbb"></i>{{ scan.UserLock }}
                        </span>
                    }
                </td>
                <td style="text-align: center; white-space: nowrap">
                    @if (canViewScan(scan)) {
                        <a
                            [routerLink]="'/scan/process'"
                            [queryParams]="{id: scan.ScanID}"
                            [nz-tooltip]="'View Scan'"
                            style="color: #333; margin-right: 8px; text-decoration: none">
                            <i class="fa-solid fa-arrow-up-right-from-square"></i>
                        </a>
                    }
                    @if (scan.CanUnlock && !canViewScan(scan)) {
                        <i
                            [nz-tooltip]="'Unlock Scan'"
                            nz-popconfirm
                            nzOkText="Unlock"
                            [nzOkDanger]="true"
                            nzPopconfirmTitle="Are you sure you want to unlock this scan?"
                            nzPopconfirmPlacement="top"
                            (nzOnConfirm)="unlockScan(scan.ScanID)"
                            style="cursor: pointer; color: #333; margin-right: 8px"
                            class="fa-solid fa-lock-open"></i>
                    }
                    @if (scan.CanDelete) {
                        <i
                            [nz-tooltip]="'Delete Scan'"
                            nz-popconfirm
                            nzOkText="Delete"
                            nzPopconfirmTitle="Are you sure you want to delete this scan?"
                            nzPopconfirmPlacement="top"
                            [nzOkDanger]="true"
                            (nzOnConfirm)="deleteScan(scan.ScanID)"
                            style="cursor: pointer; color: red"
                            class="fa-solid fa-trash"></i>
                    }
                </td>
            </tr>
        }
    </tbody>
</nz-table>

<ng-template #totalTemplate let-total>
    Showing items {{ pageIndex * pageSize - pageSize + 1 }}-{{
        pageIndex * pageSize > total ? total : pageIndex * pageSize
    }}
    out of {{ total }}
</ng-template>
